import i18next from 'i18next';
import enNs1 from '../i18n/en.json';
export const defaultNS = 'limestone';
i18next.init({
    debug: false,
    fallbackLng: 'en',
    defaultNS,
    resources: {
        en: {
            limestone: enNs1,
        }
    },
});
export default i18next;
